import React from 'react'
import "./My_team_details_card.css"

function My_team_details_card({imgSrc}) {
    return (
        <>
            <section className='My_team_details_card'>
                <div className="row">
                    <div className="col-md-4 col-sm-5 col-4">
                        <div className="img_holder">
                            <img src={imgSrc} alt="" className='teams_card_img' />
                        </div>
                    </div>

                    <div className="col-md-8 col-sm-7 col-8">
                        <div className="content_holder">
                            <div className="text_holder">
                                <h5>My Total Active Team</h5>
                            </div>
                            <div className="count_text_holder">
                                <div className="count_holder">
                                    <h6>45</h6>
                                </div>
                                <div className="name_holder">
                                    <p>Member</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default My_team_details_card